<template>
  <div style="height: calc(100vh - 135px);overflow: auto;padding-right:3px">
    <div class="page_header" style="">
      <span class="page_title" style="flex: 1;">{{ $t('statistics.空调使用统计') }}</span>
      <quickQuery @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" style="text-align: right" />
    </div>
    <div><el-divider></el-divider></div>
    <div class="page_container">
      <el-table :size="size" border :data="listData" v-loading="loading" @row-dblclick="openDetail">
        <el-table-column align="center" prop="ID" :label="$t('public.OrderIndex')" min-width=""></el-table-column>
        <el-table-column align="center" prop="CarNo" :label="$t('statistics.车辆')" min-width=""></el-table-column>
        <!-- <el-table-column align="center" prop="RunTime" :label="$t('statistics.车辆运行时间')"
          min-width="280"></el-table-column> -->
        <el-table-column align="center" prop="RunDuration" :label="$t('statistics.车辆运行时长(h)')"
          min-width=""></el-table-column>
        <el-table-column align="center" prop="AirDuration" :label="$t('statistics.空调运行时长(h)')"
          min-width=""></el-table-column>
        <el-table-column align="center" prop="RunMileage" :label="$t('statistics.车辆行驶里程(km)')"
          min-width=""></el-table-column>
        <el-table-column align="center" prop="AirMileage" :label="$t('statistics.空调开启里程(km)')"
          min-width=""></el-table-column>
        <el-table-column align="center" :label="$t('public.Detail')" min-width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">
              {{ $t('public.Detail') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <kl-pagination style="margin-bottom: 10px;" :pageSize="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="sizeChange" :current-page.sync="currentPage">
    </kl-pagination>

    <el-dialog :title="$t('statistics.空调使用统计') + '-' + $t('public.Detail')" :visible.sync="detailVisible" width="850px"
      :close-on-click-modal="false">
      <el-table :size="size" border :data="detailData" v-loading="detailLoading">
        <el-table-column align="center" prop="ID" :label="$t('public.OrderIndex')" min-width=""></el-table-column>
        <el-table-column align="center" prop="CarNo" :label="$t('statistics.车辆')" min-width=""></el-table-column>
        <el-table-column align="center" prop="RunTime" :label="$t('statistics.车辆运行时间')"
          min-width="280"></el-table-column>
        <el-table-column align="center" prop="RunDuration" :label="$t('statistics.车辆运行时长(h)')"
          min-width=""></el-table-column>
        <el-table-column align="center" prop="AirDuration" :label="$t('statistics.空调运行时长(h)')"
          min-width=""></el-table-column>
        <el-table-column align="center" prop="RunMileage" :label="$t('statistics.车辆行驶里程(km)')"
          min-width=""></el-table-column>
        <el-table-column align="center" prop="AirMileage" :label="$t('statistics.空调开启里程(km)')"
          min-width=""></el-table-column>
      </el-table>
      <kl-pagination style="margin-bottom: 10px;" :pageSize="detailPageSize" :total="detailTotal"
        @current-change="detailCurrentChange" @size-change="detailSizeChange" :current-page.sync="currentDetailPage">
      </kl-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false" :size="size">{{ $t('public.cancel') }}</el-button>
        <el-button type="primary" @click="downloadDetail" :size="size">{{ $t('public.download') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import quickQuery from '../components/generalOrQuickQuery.vue'
import { mapState } from 'vuex';
import settings from "@/settings";
export default {
  name: "ACStatistics",
  components: { quickQuery },
  data() {
    return {
      listData: [],
      loading: false,
      vehicles: "",
      beginDate: "",
      endDate: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detailVisible: false,
      currentDetailPage: 1,
      detailPageSize: 10,
      detailTotal: 0,
      detailData: [],
      detailLoading: false,
      selectedRow: null,
    }
  },
  mounted() {
    const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
  },
  computed: {
    size() {
      return this.$store.getters.size
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  methods: {
    sizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getList();
    },
    detailSizeChange(size) {
      this.currentDetailPage = 1;
      this.detailPageSize = size;
      this.getDetailList();
    },
    detailCurrentChange(val) {
      // console.log(val);
      this.currentDetailPage = val;
      this.getDetailList();
    },
    handleCurrentChange(val) {
      // console.log(val);
      this.currentPage = val;
      this.getList();
    },
    handleQuery(val) {
      // console.log(val);
      if (val.beginDate == "") {
        this.$message.warning("请选择日期");
        return;
      }
      this.beginDate = val.beginDate + " 00:00:00";
      this.endDate = val.endDate + " 23:59:59";
      this.vehicles = this.getSelectedVehicles();
      this.currentPage = 1;
      this.getList();
    },
    getSelectedVehicles() {
      this.vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
    quickQuery(val) {
      // console.log(val);
      this.beginDate = val.beginDate + " 00:00:00";
      this.endDate = val.endDate + " 23:59:59";
      this.vehicles = this.getSelectedVehicles();
      this.currentPage = 1;
      this.getList();
    },
    download() {

      this.getList(1);
    },
    openDetail(row) {

      this.selectedRow = row;
      this.detailVisible = true;
      this.getDetailList();//"");//todo
    },
    downloadDetail() {
      if (!this.selectedRow) return;
      this.getDetailList(1);//todo
    },
    getDetailList(isExport) {
      isExport = isExport || 0;
      this.detailLoading = true;
      this.$api.queryAirEnergyInfoWeb({
        vehicles: this.selectedRow.VehicleID.toString(),
        BeginDate: this.beginDate,// "2025-08-10 00:00:00",
        EndDate: this.endDate,// "2025-08-10 23:59:59",
        PageNo: this.currentDetailPage,

        PageSize: isExport == 1 ? 65535 : this.detailPageSize,
        IsExport: isExport, Language: this.$store.getters.LanguageId
      }, isExport == 1 ? 'blob' : 'json')
        .then((res) => {
          this.detailLoading = false;
          if (isExport == 1) {
            let blob = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8",
            }); // 重点代码

            let a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            a.download = this.selectedRow.CarNo + "_" + this.$t("statistics.空调使用统计详情") + '.xlsx'; // 默认文件名
            // a.setAttribute(
            //     "download",
            //     "充电记录.xlsx"
            // ); // 表名，自定义
            // document.body.appendChild(a);
            a.click(); // 执行下载
            window.URL.revokeObjectURL(blob); // 释放ur

          } else {
            this.detailData = res.data;
            this.detailTotal = res.recordsTotal;
          }


        })
        .catch((e) => {
          this.detailData = [];
          this.detailTotal = 0;
          this.detailLoading = false;
        })
    },
    getList(isExport) {
      isExport = isExport || 0;
      this.loading = true;
      this.$api.queryAirEnergyInfoDaily({
        vehicles: this.vehicles,
        BeginDate: this.beginDate,// "2025-08-10 00:00:00",
        EndDate: this.endDate,// "2025-08-10 23:59:59",
        PageNo: this.currentPage,

        PageSize: isExport == 1 ? 65535 : this.pageSize,
        IsExport: isExport, Language: this.$store.getters.LanguageId
      }, isExport == 1 ? 'blob' : 'json')
        .then((res) => {
          this.loading = false;
          if (isExport == 1) {
            let blob = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8",
            }); // 重点代码

            let a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            a.download = this.$t("statistics.空调使用统计") + '.xlsx'; // 默认文件名
            // a.setAttribute(
            //     "download",
            //     "充电记录.xlsx"
            // ); // 表名，自定义
            // document.body.appendChild(a);
            a.click(); // 执行下载
            window.URL.revokeObjectURL(blob); // 释放ur

          } else {
            this.listData = res.data;
            this.total = res.recordsTotal;
          }


        })
        .catch((e) => {
          this.listData = [];
          this.total = 0;
          this.loading = false;
        })
    },
  },

}
</script>
<style lang="scss" scoped>
.pagination {

  ::v-deep .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background-color: transparent !important;
  }

}
</style>